<label class="subHeading">Bank Name</label>
<mat-select formControlName="bank_name" multiple #bankNameSelect>
  <mat-option *ngFor="let data of loanBank" [value]="data.rb_id">
    {{data.name}}
  </mat-option>
</mat-select>